export const ENTER_KEY_CODE = 13;
export const SME_PAGE_SIZE = 1000;
export const PAGE_SIZE = 15;
export const USER_PAGE_SIZE = 20;
export const FEEDBACK_TIMER = 5000;
export const MEMBER_SELECTION_PAGE_SIZE = 100;
export const refreshTokenTimer = process.env.REACT_APP_REFRESH_TOKEN_TIMER
  ? parseInt(process.env.REACT_APP_REFRESH_TOKEN_TIMER)
  : 480000; //8 minutes timer to refresh token
export const ABOVE_PROPERTY = "ABOVE_PROPERTY";
export const IDLE_TIMEOUT = Number(process.env.REACT_APP_IDLE_TIMEOUT);
export const LOGOUT_URL = "https://fdstg.hilton.com/idp/startSLO.ping";
export const statusTypes = ["New", "In Progress", "Completed"];
export const logoutTimer = 120;

export const planTypes = [
  { planTypeId: 1, planTypeName: "Brand Deadline" },
  { planTypeId: 0, planTypeName: "Opportunities" },
  { planTypeId: 2, planTypeName: "Initiative" }
];
export const corpFilterTypeConst = {
  innCode: "innCode",
  planName: "planName",
  functionalArea: "functionalArea",
  management: "management",
  ownerGroup: "ownerGroup",
  owners: "owners",
  members: "members",
  property: "property"
};

export const planDetailsMetaKeyMap: any = {
  region: "regions",
  brandCode: "brandCodes",
  locationType: "locationTypes",
  mgmtType: "managementTypes"
};

export const corpFilterConstants: any = {
  innCode: ["inncode", "filteredInnCodes", "innCode"],
  planName: ["planCmsId", "ids", "cmsId"],
  functionalArea: ["functionalAreaId", "functionalAreaIds", "functionalArea"],
  management: ["managementCompany"],
  ownerGroup: ["ownerGroup"],
  owners: ["planOwner"],
  members: ["hltIds", "hltId", "users", "searchedHltId", "assignedBy"],
  property: ["staticListIds"]
};

export const uiToPayloadExperienceLevel = [
  { label: "New to my role", value: "Yes, new to my role" },
  { label: "New to my brand", value: "Yes, new to my brand" },
  { label: "New to my role and my brand", value: "Yes, new to my role and my brand" },
  { label: "Experienced", value: "No" }
];

export const missingIncodeText = "Missing_inncode_mapping";
export const DEFAULT_CORP_INNCODE = "CORP";
export const CORPORATE_USER = "CU";
export const ABOVE_PROP_USER_TYPE = "ow";
export const ABOVE_PROPERTY_DISPLAY_TYPE = "Above Property";
export const ON_PROPERTY_DISPLAY_TYPE = "On Property";
export const corpUser = ["cc", "ce"];
export const brandDeadlinesType = 1;
export const initiativePlansType = 2;
export const abovePropUserLobbyType = "OW";
export const allPlansType = 0;
export const includeAboveProperty = "includeAboveProperty";
export const brandDeadLine = "BRAND_DEADLINE";
export const initiative = "INITIATIVE";
export const RECOMMENDATION = "recommendation";
export const RETRIEVE_NOTIFICATION_EVENT_TYPE =
  "COMMENTS_WITH_USER_TAGS,MEMBER_REMOVAL_ACTION,MEMBER_REMOVAL_PLAN,STAGNANT_PLAN";

export const PlanAssigmentLimit = process.env.REACT_APP_ACTIVE_PLAN_ASSIGNMENT_LIMIT
  ? parseInt(process.env.REACT_APP_ACTIVE_PLAN_ASSIGNMENT_LIMIT)
  : 2500;
export const PlanSelectionLimit = process.env.REACT_APP_ACTIVE_PLAN_SELECTION_LIMIT
  ? parseInt(process.env.REACT_APP_ACTIVE_PLAN_SELECTION_LIMIT)
  : 10;
export const ManageSuggestionPlansLimit = 1000;

export const sourceValues = {
  library: "library",
  librarySearch: "library_search",
  deadline: "brand_deadline",
  initiative: "initiative",
  assignedSme: "assigned_SME",
  sharedLink: "shared_link",
  bookmark: "library_bookmark",
  consultantBookmark: "consultant_assigned_bookmarked",
  managementBookmark: "management_assigned_bookmarked",
  leaderBookmark: "leader_assigned_bookmarked",
  sharedSearch: "shared_search"
};

export const abovePropUserView = {
  AP: "My View",
  HU: "Team Member View"
};

export const americanRegion = [
  "CA",
  "MX",
  "US",
  "PR",
  "BS",
  "DO",
  "KN",
  "AW",
  "JM",
  "BM",
  "SX",
  "BB",
  "HT",
  "LC",
  "KY",
  "TT",
  "DM",
  "DO",
  "AI",
  "PF",
  "AR",
  "BR",
  "PE",
  "CO",
  "CL",
  "BO",
  "EC",
  "UY",
  "CW",
  "PY",
  "CR",
  "PA",
  "BZ",
  "GT",
  "SV",
  "NI",
  "HN"
];

export const EMEAregion = [
  "AL",
  "DZ",
  "AD",
  "AO",
  "AM",
  "AT",
  "AZ",
  "AZ",
  "BH",
  "BY",
  "BE",
  "BA",
  "BW",
  "BG",
  "CM",
  "CV",
  "TD",
  "HR",
  "CY",
  "CZ",
  "CD",
  "DK",
  "EG",
  "EE",
  "ET",
  "MK",
  "FO",
  "FI",
  "FR",
  "GE",
  "DE",
  "GH",
  "GR",
  "HU",
  "IS",
  "IQ",
  "IE",
  "IL",
  "IL",
  "IT",
  "JO",
  "KZ",
  "KE",
  "XK",
  "KW",
  "KG",
  "LV",
  "LB",
  "LR",
  "LT",
  "LU",
  "MG",
  "MW",
  "MT",
  "MR",
  "MU",
  "MD",
  "MC",
  "ME",
  "MA",
  "MZ",
  "NA",
  "NL",
  "NG",
  "NO",
  "OM",
  "PK",
  "PL",
  "PT",
  "QA",
  "RE",
  "RO",
  "RU",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SK",
  "SI",
  "ZA",
  "ES",
  "SZ",
  "SE",
  "CH",
  "TJ",
  "TZ",
  "CG",
  "TN",
  "TR",
  "UG",
  "UA",
  "AE",
  "GB",
  "UZ",
  "ZM",
  "ZW"
];

export const APACregion = [
  "AU",
  "BD",
  "BT",
  "KH",
  "CN",
  "FJ",
  "GU",
  "HK",
  "IN",
  "ID",
  "JP",
  "KR",
  "LA",
  "MO",
  "MY",
  "MV",
  "MM",
  "NP",
  "NC",
  "NZ",
  "PG",
  "PH",
  "SG",
  "LK",
  "TW",
  "TH",
  "TL",
  "VN"
];

export const messageTypes = {
  singleOwner: "singleOwner",
  multipleOwners: "multipleOwners",
  deadlinePlan: "brand deadline",
  initiativePlan: "initiative"
};
export const threshold = {
  Outstanding: "outstanding",
  Unacceptable: "unacceptable",
  Acceptable: "acceptable"
};
export const showText = {
  showMore: "Show More",
  showLess: "Show Less"
};

export const markCompleteSuccessMessage: any = {
  plan: "All action(s) selected have been marked completed.",
  section_highlighted: "All action(s) selected have been marked completed.",
  section: "All actions in this section are completed.",
  section_multiselect: "All selected actions are completed."
};

export const messages = {
  planAdded: "Plan Added. Splendid! Now it's time to start delegating and working on actions.",
  editSuccess: "Your edits have been saved.",
  actionAdded: "Action Added. Well-done customizing your plan!",
  memberInvited: "Plan Member Invited",
  memberRemoved: "Plan Member Removed",
  requiredField: "This field is required to be completed.",
  mustHaveSingleOwner: "Assign a Plan Member as the Owner. There must be at least one Owner for each plan. ",
  planNotFound:
    "The chosen Plan does not apply to the selected filters (brand, region, etc.). Please return to the Library and search for another plan.",
  listUploadSuccess: "Inncode list uploaded",
  listNotCreated: "Inncode list not created as there are no valid entries.",
  listDeleteSuccess: "List was successfully deleted",
  userNotFound:
    "The Team Member you searched couldn't be found. Please verify spelling is correct. Each Team Member must log in at least once and complete the wizard before items can be assigned to them.",
  importInncodeFailure: "Inncode List is uploaded. The following Inncodes were found invalid.",
  assignPlanConfirmation:
    "Plan assignments are in progress. It may take some time for the assigned plans to appear in the list. Once the assignment has been completed, you will receive a confirmation email.",
  noProperties: "There are no properties selected to show the members",
  deleteNotifications: "This will permanently delete all the notifications. Do you wish to proceed?",
  noAbovePropertiesData: "There are no Properties",
  noAbovePropertiesMembers: "There are no Members",
  noPropertyPlans: "There are no Plans",
  noOwners: "No plan owners found",
  noAssignee: "No plan assignee found"
};

export const optionTypeArray = [
  "key-value-array",
  "key-array-value-array",
  "key-value-array-local",
  "static-single-select-key-value"
];

export const sourceList = [
  { name: "Library", value: ["library", "library_search"] },
  { name: "Brand Deadline", value: ["brand_deadline"] },
  { name: "Initiative", value: ["initiative"] },
  {
    name: "Suggested",
    value: ["recommended_default", "recommended_criteria", "recommended_brand_deadline", "recommended_initiative"]
  },
  { name: "Consultant Assigned", value: ["assigned_SME"] },
  { name: "Management Assigned", value: ["management_assigned"] },
  { name: "Shared Link", value: ["shared_link"] },
  { name: "Leader Assigned", value: ["leader_assigned"] },
  { name: "Shared Search", value: ["shared_search"] }
];

export const minSearchStrLength = 2;
export const invitee = "INVITEE_USER";
export const singleAssignee = "SINGLE_ASSIGNEE_USER";
export const multipleAssignee = "MULTIPLE_ASSIGNEE_USER";
type sourceKeyType = {
  [key: string]: string;
};
export const planSourceList: sourceKeyType = {
  library: "Library",
  library_search: "Library",
  brand_deadline: "Brand Deadline",
  initiative: "Initiative",
  recommended_criteria: "Suggested",
  recommended_default: "Suggested",
  recommended_brand_deadline: "Suggested",
  recommended_initiative: "Suggested",
  assigned_SME: "Consultant Assigned",
  management_assigned: "Management Assigned",
  shared_link: "Shared Link",
  leader_assigned: "Leader Assigned",
  library_bookmark: "Library",
  leader_assigned_bookmarked: "Leader Assigned",
  management_assigned_bookmarked: "Management Assigned",
  consultant_assigned_bookmarked: "Consultant Assigned",
  shared_search: "Shared Search"
};

export const abovePropertyAssign = { single: "single", multiple: "multiple" };
export const abovePropertyViewTypePlan = "BOOKMARK_PLANS";
export const completed = "Completed";
export const abovePropertyViewTypeProperty = "BOOKMARK_PROPERTIES";
export const abovePropertyViewTypeTemplate = "BOOKMARK_TEMPLATE_PLANS";
export const abovePropertyViewTypePlanTemplate = "BOOKMARK_TEMPLATE_PLANS,BOOKMARK_PLANS";
export const noAbovePropertyPlans = "There are no Plans to show.";
export const roleCategoryList = ["Leadership", "Non-Leadership"];
export const dummyInnCodes = ["owner", "above_property", "franchise"];
export const tabConstants = {
  libraryPlans: "Implemented Library Plans",
  AssignedCustomPlans: "Assigned Template Plans",
  BrandDeadline: "Brand Deadlines",
  BrandInitiative: "Initiatives"
};

//Regex
export const regExpForId = /\[~~([A-Z0-9]+)~~\]/g;
export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const urlRegex = /^(https?|ftp):\/\/|^www\./;
export const accessTypes = {
  view: "View",
  update: "Edit",
  delete: "Delete",
  assign: "Assign"
};
export const DISPLAY_TYPE = {
  noPlans: "no_plans",
  myPlansOverview: "my_plans_overview",
  highlights: "highlights",
  userDashboardMyPlans: "user_dashboard_MyPlans",
  userDashboardHighlights: "user_dashboard_Highlights",
  bookmarkedPropertiesPlans: "bookmarked_properties_plans"
};
export const myListsTexts: { [key: string]: string } = {
  bookmarked: "bookmarked",
  Bookmarked: "Bookmarked",
  savedFilters: "Saved Filters",
  dynamic: "dynamic",
  savedPropertyLists: "Saved Property Lists",
  static: "static"
};
export const corpViewTypes: { [key: string]: string } = {
  myList: "myList",
  dashboard: "dashboard"
};
export const progressTypes: { [key: string]: string } = {
  plan: "plan",
  property: "property",
  user: "users"
};

export const sortableProperties: { [key: string]: string } = {
  Inncode: "inncode",
  "*All Plans": "implementedPlansCount",
  Plans: "implementedPlansCount",
  "*Plans": "implementedPlansCount",
  "Property Engagement": "propertyEngagement",
  Plan: "planTitle",
  Properties: "implementedPropertiesCount",
  Assignments: "assigneesCount",
  "User type": "userType",
  Permissions: "permissions",
  "Last Active": "lastLoggedInDate",
  "Plan Name": "title",
  Priority: "priority",
  "Due Date": "dueDate",
  Region: "region",
  "Suggested Plans": "suggestedPlansCount",
  Brand: "brandName",
  "Trigger points": "triggerPoint",
  "Feedback type": "type",
  "Nr of questions": "numberOfQuestions"
};

export const helperTexts: { [key: string]: string } = {
  Corporate: "Default user type",
  Consultant: "Manage consultant lists & assignments",
  Permissions: "Access to Hotel User's Plans",
  "Manage Feedback": "Manage Feedback permissions",
  "Admin Console": "Manage members' permissions",
  "Manage Suggestions": "Access to upload recommendations",
  "Manage Metrics": "Access to upload and download Metrics"
};
